/** Маппер AccountListItem гейтвея → доменный Account */

import type {Account, AccountMembership} from './types';

type Raw = Record<string, unknown>;
const asObj = (v: unknown): Raw => (typeof v === 'object' && v !== null ? (v as Raw) : {});
const asStr = (v: unknown, d = ''): string => (typeof v === 'string' ? v : d);
const strN = (v: unknown): string | null => (typeof v === 'string' && v !== '' ? v : null);

const toMembership = (raw: unknown): AccountMembership => {
  const r = asObj(raw);
  return {
    membershipId: asStr(r.membershipId),
    clinicId: asStr(r.clinicId),
    clinicName: asStr(r.clinicName, '—'),
    roleName: asStr(r.roleName),
    isOwner: r.isOwner === true,
    active: r.active !== false,
  };
};

export const toAccount = (raw: unknown): Account => {
  const r = asObj(raw);
  return {
    id: asStr(r.id),
    fullName: asStr(r.fullName, '—') || '—',
    phone: asStr(r.phone),
    isPlatformAdmin: r.isPlatformAdmin === true,
    blocked: r.blocked === true,
    blockedAt: strN(r.blockedAt),
    blockedReason: strN(r.blockedReason),
    hasActiveMembership: r.hasActiveMembership === true,
    memberships: (Array.isArray(r.memberships) ? r.memberships : []).map(toMembership),
    createdAt: asStr(r.createdAt),
  };
};
